// extracted by mini-css-extract-plugin
export default {"root":"ExternalDnsAddForm_root__ryvz9","natTarget":"ExternalDnsAddForm_natTarget__wcAcJ","asset":"ExternalDnsAddForm_asset__xatHE","hostname":"ExternalDnsAddForm_hostname__Xg0if"};